(function () {
    'use strict';
    angular.module('app.common')
        .directive('investmentCardLanding', [function () {
            var directive = {
                templateUrl: '/app/common/investment-card.html',
                scope: {
                    data: '<'
                },
                restrict: 'EA',
                replace: false,
                link: function(scope, element, attrs) {                
                    scope.lastUpdateDate = function(investment) {
                        return investment.UpdateDate || investment.CreateDate;
                    };
                    
                    function calculateDaysPast (firstDate , lastDate) { 
                        var start = moment(firstDate); 
                        var end = moment(lastDate);
                        
                        var duration = Math.ceil(moment.duration(end.diff(start)).asDays());
                        
                        return duration
                    }
                    
                    // Calculate daysPast for current data - same logic as investmentController
                    if (scope.data) {
                        let lastDate;
                        if (scope.data.ListingActive) {
                            lastDate = new Date();
                        } else {
                            lastDate = new Date(scope.data.LastActivityDate);
                        }
                        
                        scope.data.daysPast = calculateDaysPast(scope.data.CreateDate, lastDate);
                    }
                }
            };
            return directive;
        }]);
})();
